import { useContext, useEffect, useState } from "react";
import { tenantContext } from "../Main/contexts";
import { Departments, GetDepartmentResponse, GetDepartments } from "../Logic/department";
import { CreateDepartment, DeleteDepartment, DerpartmentList, UpdateDepartment } from "./TenantAPI";
import DataTable, { dataColumn } from "../Generic/DataTable";
import { sortByField, SortEnquiriesParams } from "../Logic/sort";
import Loading from "../Generic/loading";
import TextBox from "../Generic/TextBox";
import { lengthIsLessThan } from "../Logic/validationRules";
import { PlusCircle } from "react-feather";

function Index() {
    const { selectedTenant, departments, setDepartments } = useContext(tenantContext);
    const [isLoading, setIsLoading] = useState<Boolean>(true);
    const [filtertedGridaData, setFiltertedGridaData] = useState<Array<DerpartmentList>>([]);
    const [sortBy, setSortBy] = useState<SortEnquiriesParams>();
    const [selectedItem, setSelectedItem] = useState<Departments>({ name: "", id: 0 });
    const [validationErrors, setValidationErrors] = useState<Array<string>>([]);
    const [isNew, setIsNew] = useState<Boolean | undefined>(undefined);
    useEffect(() => {
        (async () => {
            await getDepartments();
        })();
    }, [selectedTenant]);

    async function getDepartments() {
        if (selectedTenant) {
            const departments_results = GetDepartments(selectedTenant.token);
            Promise.all([departments_results]).then(results => {
                if (results[0].isOk) {
                    setDepartments(results[0].data?.items!);
                    setFiltertedGridaData(results[0].data?.items!);
                }
                setIsLoading(false);
            });
        }
    }

    let AllColumns: dataColumn<DerpartmentList>[] = [
        {
            title: <>Departments</>,
            toolTip: "name",
            key: "name",
            getData: (data: DerpartmentList) => {
                return <>{data.name}</>;
            },
            width: "100%",
            canResize: false,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    handleHeaderClick("name");
                },
                displayIcon: false,
            },
            textAlignment: "left",
            minWidth: "60px",
        },
    ];

    const handleHeaderClick = (fieldName: string): any => {
        let sortO = sortBy;
        if (!sortO) {
            sortO = {
                orderBy: fieldName,
                desc: false,
            };
        } else {
            sortO.orderBy = fieldName;
            sortO.desc = sortO.desc ? false : true;
        }
        let updatedGrids = sortByField(filtertedGridaData, fieldName, sortO.desc);
        setDepartments(updatedGrids);
        setSortBy(sortO);
    };
    function OnFilter(filterValue: string) {
        let filtertedList = departments;
        let filtered = filtertedList.filter(x => x.name.toLowerCase().includes(filterValue.toLowerCase()));
        setFiltertedGridaData(filtered);
    }
    function getDepartmentInfo(val: string) {
        const dept = departments.find(x => x.id.toString() == val);
        if (dept) {
            setSelectedItem(dept);
            setIsNew(false);
        }
    }
    const addDepartment = () => {
        setSelectedItem({ name: "", id: 0 });
        setIsNew(true);
    };
    const updateDepartment = async () => {
        if (selectedTenant) {
            if (selectedItem.name.length > 0 && selectedItem.name.length < 31 && selectedItem.id > 0) {
                const result = await UpdateDepartment(selectedTenant.token, selectedItem.id, {
                    name: selectedItem.name,
                });
                if (result.isOk) {
                    await getDepartments();
                    alert("updated successfully");
                }
            } else {
                alert("An Error occured name is invalid or no department selected to update");
            }
        }
    };

    const deleteDepartment = async () => {
        if (selectedTenant) {
            if (selectedItem.id > 0) {
                let confirmDelete = window.confirm("Are you sure you want to delete this Department?");
                if (confirmDelete) {
                    const result = await DeleteDepartment(selectedTenant.token, selectedItem.id);

                    if (result.isOk) {
                        if (result.data && result.data.validationErrors && result.data.validationErrors) {
                            alert(Object.values(result.data.validationErrors));
                        } else {
                            await getDepartments();
                            alert("Delete successfully");
                            setIsNew(undefined);
                        }
                    } else {
                        alert(result.statusText);
                    }
                }
            } else {
                alert("An Error occured name is invalid or no department selected to update");
            }
        }
    };

    const createDepartment = async () => {
        if (selectedTenant && selectedItem.name.length > 0 && selectedItem.name.length < 31) {
            const result = await CreateDepartment(selectedTenant.token, { name: selectedItem.name });
            if (result.isOk) {
                await getDepartments();
                alert("Added successfully");
                setIsNew(undefined);
            }
        } else {
            alert("An Error occured. Name is invalid , length has to be between 1 and 30 characted");
        }
    };

    return (
        <>
            <div className="topSection">
                <div className="sectionHeader">
                    <PlusCircle
                        className="headerIcon"
                        onClick={addDepartment}
                    ></PlusCircle>{" "}
                    Departments
                </div>
                {selectedItem && isNew == false && (
                    <div>
                        <button
                            className="g-btn-large btn-warning"
                            onClick={deleteDepartment}
                        >
                            {" "}
                            Delete Department
                        </button>{" "}
                        <button
                            className="g-btn-large btn-primary"
                            onClick={updateDepartment}
                        >
                            {" "}
                            Update Department{" "}
                        </button>
                    </div>
                )}
                {selectedItem && isNew == true && (
                    <div>
                        <button
                            className="g-btn-large btn-primary"
                            onClick={createDepartment}
                        >
                            {" "}
                            Create Department{" "}
                        </button>
                    </div>
                )}
            </div>
            <div style={{ display: "flex", flexDirection: "row", height: "calc(100% - 51px)" }}>
                <div className="bodyCol1">
                    {" "}
                    {isLoading && <Loading></Loading>}
                    {!isLoading && (
                        <>
                            <div className="filterContainer">
                                <div>Filter: </div>
                                <div>
                                    <input
                                        type="text"
                                        style={{ width: "100%" }}
                                        onChange={e => OnFilter(e.currentTarget.value)}
                                    />
                                </div>
                            </div>
                            <DataTable
                                data={filtertedGridaData}
                                columns={AllColumns}
                                onRowClick={(val: string) => {
                                    getDepartmentInfo(val);
                                }}
                                onRowDblClick={() => {}}
                                selectedItem={selectedItem.id.toString()}
                                uniqueIdentifiyer={x => {
                                    return x.id.toString();
                                }}
                            ></DataTable>
                        </>
                    )}
                </div>
                {isNew != undefined && (
                    <div className="bodyCol2">
                        <div className="optionsRow">
                            <p style={{ marginBottom: "6px", marginTop: "-0px", fontWeight: "bold", fontSize: "12pt" }}>
                                {!isNew ? "Edit" : "Create"} Department{" "}
                            </p>
                        </div>
                        <div className="formRow">
                            <TextBox
                                id={"name"}
                                label="Name"
                                value={selectedItem.name}
                                onChange={(field: string, value: any) => {
                                    setSelectedItem({ ...selectedItem, name: value });
                                }}
                                maxLength={30}
                                requiredIdentifier={true}
                                errorMessage={
                                    validationErrors.find(x => x == "name")
                                        ? "Field must be less than 30 characters"
                                        : ""
                                }
                                validationFunc={lengthIsLessThan}
                            ></TextBox>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
export default Index;
